
import {
  get_display_caption,
  get_time,
  scroll_to_bottom,
  get_messages,
  get_date_from_now,
  is_date_change,
  send_message,
  set_typing,
  is_image,
  get_avatar_html,
  quote_label,
  is_document_file
} from './wachat_utils';

export default class WachatSpace {
  constructor(opts) {
    this.wachat_list = opts.wachat_list;
    this.$wrapper = opts.$wrapper;
    this.profile = opts.profile;

    this.lasttime = frappe.datetime.now_datetime();
    this.type_msg = null;
    this.timediff = 24;
    this.file = null;

    // this.pageSize = 5;
    // this.displayStart = 0;
    // this.displayEnd = 0;
    this.allMessages = [];

    this.pageSize = 20;
    this.messages = [];
    this.hasOlder = false;
    this.loadingOlder = false;


    this.setup();
  }

  setup() {
    this.$wachat_space = $(document.createElement('div'));
    this.typing = false;
    this.$wachat_space.addClass('wachat-space');
    this.setup_header();
    this.fetch_and_setup_messages();
    this.setup_socketio();
  }

  setup_header() {
    this.avatar_html = get_avatar_html(
      this.profile.room_type,
      this.profile.opposite_person_email,
      this.profile.room_name
    );
    const header_html = `
			<div class='wachat-header'>
				${this.profile.is_admin === true
        ? `<span class='wachat-back-button' title='${__('Go Back')}' >
								${frappe.utils.icon('left')}
							</span>`
        : ``
      }
				${this.avatar_html}
				<div class='wachat-profile-info'>
					<div class='wachat-profile-name'>
					${__(this.profile.room_name.substring(0, 20))}
					<div class='online-circle'></div>
					</div>
					<div class='wachat-profile-status'>${__('Typing...')}</div>
				</div>
			</div>
		`;
    this.$wachat_space.append(header_html);
  }


  async fetch_and_setup_messages() {
    try {
      const res = await get_messages(this.profile.room, this.profile.user_email, {
        limit: this.pageSize,
      });
      this.messages = res.messages || [];
      this.hasOlder = !!res.has_older;
      this.setup_messages();
      this.setup_actions();
      this.render();
    } catch (error) {
      console.error("Message Fetch Error:", error);
      frappe.msgprint({ title: __('Error'), message: __('Something went wrong.') });
    }
  }

  setup_messages(messages_list) {
    this.$wachat_space_container = $(document.createElement('div'));
    this.$wachat_space_container.addClass('wachat-space-container');
    this.$wachat_space.append(this.$wachat_space_container);

    this.$wachat_messages = $(document.createElement('div'));
    this.$wachat_messages.addClass('wachat-messages');
    this.$wachat_space_container.append(this.$wachat_messages);


    this.$floating_btn_wrap = $(`
    <div class="wachat-floating-load"></div>
`).css({
      position: 'absolute',
      left: '50%',
      top: '43px',
      transform: 'translateX(-50%)',
      zIndex: '1000',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 'max-content',
      height: 'auto',
      background: 'transparent',
      border: 'none',
      padding: '0',
      margin: '0',
      opacity: '1',
      visibility: 'visible'
    });

    this.$floating_btn = $(`
    <button class="wachat-load-prev-btn">
        ↑ ${__('Show Previous')}
    </button>
`).css({
      pointerEvents: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '6px 14px',
      background: '#ffffff',
      color: '#333333',
      border: '1px solid #d1d5db',
      borderRadius: '20px',
      fontSize: '12px',
      fontWeight: '500',
      lineHeight: '18px',
      cursor: 'pointer',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
      whiteSpace: 'nowrap',
      opacity: '1',
      visibility: 'visible'
    });

    this.$floating_btn_wrap.append(this.$floating_btn);
    this.$wachat_space.append(this.$floating_btn_wrap);

    this.updateFloatingButtonVisibility();

    this.$floating_btn.on('click', () => {
      this.loadPreviousBatch();
    });

    const me = this;
    this.$wachat_space_container.on('scroll', function () {
      const top = me.$wachat_space_container.scrollTop();
      me.updateFloatingButtonVisibility();
    });

    this.renderVisibleMessages({ scrollToBottom: true });
  }


  updateFloatingButtonVisibility() {
    this.hasOlder ? this.$floating_btn_wrap.show() : this.$floating_btn_wrap.hide();
  }


  renderVisibleMessages({ scrollToBottom = false } = {}) {

    this.$wachat_messages.empty();
    this.prevMessage = {};
    this.messages.forEach((element) => {
      const date_line_html = this.make_date_line_html(element.creation);
      if (date_line_html) {
        this.$wachat_messages.append($(date_line_html));
      }
      let message_type = 'recipient';
      if (element.sender_email === this.profile.user_email) {
        message_type = 'recipient';
      } else if (this.profile.room_type === 'Guest') {
        if (this.profile.is_admin === true && element.sender !== 'Guest') {
          message_type = 'recipient';
        }
      }
      if (element.client == 1) {
        message_type = 'sender';
      }
      if (message_type == 'sender' && element.is_template == 0) {
        this.lasttime = element.creation;
        this.timediff = frappe.datetime.get_hour_diff(frappe.datetime.now_datetime(), this.lasttime);
      }
      const waId = element.message_id || element.name || "";
      const $msgEl = this.make_message(
        element.content,
        element.attachment,
        get_time(element.creation),
        message_type,
        element.sender,
        element.status,
        waId,
        element.reply_to_message_id,
        element.reply_preview,
        element.reply_attachment,
        element.file_type,
        element.reply_file_type
      );
      this.$wachat_messages.append($msgEl);
      this.prevMessage = element;
    });
    this.updateFloatingButtonVisibility();
    if (scrollToBottom) {
      this.$wachat_space_container[0].scrollTop =
        this.$wachat_space_container[0].scrollHeight;
    }
  }


  async loadPreviousBatch() {
    console.log('prev', this.hasOlder, this.loadingOlder, this.messages.length, !!this.$wachat_space_container?.[0]);

    if (!this.hasOlder || this.loadingOlder || !this.messages.length) return;
    if (!this.$wachat_space_container || !this.$wachat_space_container[0]) return;

    this.loadingOlder = true;
    this.$floating_btn.prop("disabled", true).text(__("Loading..."));
    try {
      const oldest = this.messages[0];
      const container = this.$wachat_space_container[0];
      const oldHeight = container.scrollHeight;
      const oldTop = container.scrollTop;

      const res = await get_messages(this.profile.room, this.profile.user_email, {
        limit: this.pageSize,
        freeze: false,
        before_creation: oldest.creation,
        before_name: oldest.name,
      });

      const older = res.messages || [];
      this.hasOlder = !!res.has_older;
      this.messages = older.concat(this.messages);

      const $frag = $(document.createDocumentFragment());
      // this.prevMessage = {};
      older.forEach((element) => {
        const dateHtml = this.make_date_line_html(element.creation);
        if (dateHtml) $frag.append($(dateHtml));
        let message_type = 'recipient';
        if (element.client == 1) {
          message_type = 'sender';
        }
        $frag.append(
          this.make_message(
            element.content,
            element.attachment,
            get_time(element.creation),
            message_type,
            element.sender,
            element.status,
            element.message_id || element.name || '',
            element.reply_to_message_id,
            element.reply_preview,
            element.reply_attachment,
            element.file_type,
            element.reply_file_type
          )
        );
        this.prevMessage = element;
      });
      this.$wachat_messages.prepend($frag);

      container.scrollTop = container.scrollHeight - oldHeight + oldTop;
      this.updateFloatingButtonVisibility();
    } catch (e) {
      console.error(e);
      frappe.show_alert({ message: __("Could not load older messages"), indicator: "red" });
    } finally {
      this.loadingOlder = false;
      this.$floating_btn.prop("disabled", false).text(`↑ ${__("Show Previous")}`);
    }
  }


  make_messages_html(messages_list) {
    this.prevMessage = {};
    this.message_html = ``;
    if (this.profile.message) {
      messages_list.push(this.profile.message);
      send_message(
        this.profile.message.content,
        this.profile.user,
        this.profile.room,
        this.profile.user_email
      );
    }
    messages_list.forEach((element) => {
      const date_line_html = this.make_date_line_html(element.creation);
      this.message_html += date_line_html;

      let message_type = 'recipient';

      if (element.sender_email === this.profile.user_email) {
        message_type = 'recipient';
      } else if (this.profile.room_type === 'Guest') {
        if (this.profile.is_admin === true && element.sender !== 'Guest') {
          message_type = 'recipient';
        }
      }
      if (element.client == 1) {
        message_type = 'sender';
      }
      if (message_type == 'sender' && element.is_template == 0) {
        this.lasttime = element.creation;
        this.timediff = frappe.datetime.get_hour_diff(frappe.datetime.now_datetime(), this.lasttime);
      }
      const waId2 = element.message_id || "";
      this.message_html += this.make_message(
        element.content,
        element.attachment,
        get_time(element.creation),
        message_type,
        element.sender,
        element.status,
        waId2,                       // 7th arg
        element.reply_to_message_id,
        element.reply_preview,
        element.reply_attachment,
        element.file_type,
        element.reply_file_type
      ).prop('outerHTML');

      this.prevMessage = element;
    });
  }

  make_date_line_html(dateObj) {
    let result = `
			<div class='date-line'>
				<span>
					${__(get_date_from_now(dateObj, 'space'))}
				</span>
			</div>
		`;
    if ($.isEmptyObject(this.prevMessage)) {
      return result;
    } else if (is_date_change(dateObj, this.prevMessage.creation)) {
      return result;
    } else {
      return '';
    }
  }

  setup_actions() {
    this.$wachat_actions = $(document.createElement('div'));
    this.$wachat_actions.addClass('wachat-space-actions');
    this.type_msg = `
			<input disabled class='form-control type-message' 
				type='search' 
				placeholder='${__('Exceeded 24 Hrs Send Templates')}'
			>
		`;
    if (this.timediff < 23) {
      this.type_msg = `
			<input class='form-control type-message' 
				type='search' 
				placeholder='${__('Types message')}'
			>
		`;
    }
    const wachat_actions_html = `
			<span class='open-attach-items'>
				${frappe.utils.icon('attachment', 'lg')}
			</span>
			<input type='file' id='wachat-file-uploader' 
				accept='image/*, application/pdf, .doc, .docx'
				style='display: none;'
			>
			${this.type_msg}
			<div>
				<span class='message-send-button'>
					<svg xmlns="http://www.w3.org/2000/svg" width="1.1rem" height="1.1rem" viewBox="0 0 24 24">
						<path d="M24 0l-6 22-8.129-7.239 7.802-8.234-10.458 7.227-7.215-1.754 24-12zm-15 16.668v7.332l3.258-4.431-3.258-2.901z"/>
					</svg>
				</span>
			</div>
		`;
    this.$wachat_actions.html(wachat_actions_html);

    this.$reply_preview = $(`
        <div class="wachat-reply-preview">
            <span class="wachat-reply-sender"></span>
            <span class="wachat-reply-text"></span>
            <span class="wachat-reply-close">×</span>
        </div>
    `);

    // Close button handler
    this.$reply_preview.find('.wachat-reply-close')
      .off('click')
      .on('click', () => {
        this.$reply_preview.hide();
        this.reply_to = null;
      });

    this.$wachat_space.append(this.$reply_preview);
    this.$wachat_space.append(this.$wachat_actions);
  }

  async handle_upload_file(file) {
    const dataurl = await frappe.dom.file_to_base64(file.file_obj);
    file.dataurl = dataurl;
    file.name = file.file_obj.name;
    return this.upload_file(file);
  }

  upload_file(file) {
    const me = this;
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();

      xhr.upload.addEventListener('load', () => {
        resolve();
      });

      xhr.addEventListener('error', () => {
        reject(frappe.throw(__('Internal Server Error')));
      });
      xhr.onreadystatechange = () => {
        if (xhr.readyState == XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            let r = null;
            let file_doc = null;
            try {
              r = JSON.parse(xhr.responseText);
              if (r.message.doctype === 'File') {
                file_doc = r.message;
              }
            } catch (e) {
              r = xhr.responseText;
            }
            try {
              if (file_doc === null) {
                reject(frappe.throw(__('File upload failed!')));
              }
              me.handle_send_message(file_doc.file_url);
            } catch (error) {
              //pass
            }
          } else {
            try {
              const error = JSON.parse(xhr.responseText);
              const messages = JSON.parse(error._server_messages);
              const errorObj = JSON.parse(messages[0]);
              reject(frappe.throw(__(errorObj.message)));
            } catch (e) {
              // pass
            }
          }
        }
      };

      xhr.open('POST', '/api/method/upload_file', true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('X-Frappe-CSRF-Token', frappe.csrf_token);

      let form_data = new FormData();

      form_data.append('file', file.file_obj, file.name);
      form_data.append('is_private', +false);

      form_data.append('doctype', 'Wachat Room');
      form_data.append('docname', this.profile.room);
      form_data.append('optimize', +true);
      form_data.append('optimize', 0);
      xhr.send(form_data);
    });
  }

  open_file_uploader() {
    const me = this;
    let restrictions = {
      allowed_file_types: []
    };
    let options = {
      allow_multiple: true,
      restrictions: restrictions,
      on_success: (file) => {
        frappe.db.get_doc('File', file.name)
          .then(filedoc => {
            console.log(filedoc);
            this.$wachat_messages.append(
              this.make_message('Media Attachment', filedoc.file_url, get_time(), 'recipient', this.profile.user)
            );
            this.allMessages.push({
              content: filedoc.file_url,
              attachment: filedoc.file_url,
              sender: this.profile.user,
              creation: frappe.datetime.now_datetime(),
              sender_email: this.profile.user_email,
              client: 0,
              is_template: 0
            });
            this.displayEnd = this.allMessages.length;
            if (this.displayEnd - this.displayStart > this.pageSize) {
              this.displayStart = Math.max(0, this.displayEnd - this.pageSize);
            }
            scroll_to_bottom(this.$wachat_space_container);
          });
        alert('Success');
      },
    };
    options.doctype = 'Wachat Room';
    options.docname = this.profile.room;
    options.disable_file_browser = 1;
    new frappe.ui.FileUploader(options);
  }

  setup_events() {
    if (this.events_bound) return;
    this.events_bound = true;

    const me = this;
    const $root = this.$wachat_space;
    //Timeout function
    me.typing_timeout = () => {
      me.typing = false;
    };

    $root.find('.wachat-back-button').on('click', function () {
      me.wachat_list.render_messages();
      me.wachat_list.render();
    });

    $root.find('.open-attach-items').on('click', function () {
      me.open_file_uploader();
      // $root.find('#wachat-file-uploader').click();
    });

    $root.find('#wachat-file-uploader').on('change', function () {
      if (this.files.length > 0) {
        me.file = {};
        me.file.file_obj = this.files[0];
        me.handle_upload_file(me.file);
        me.file = null;
      }
    });

    $root.find('.message-send-button').on('click', function () {
      me.handle_send_message();
    });

    $root.find('.type-message').keydown(function (e) {
      if (e.which === 13) {
        me.handle_send_message();
      } else {
        //Set as typing
        if (me.typing === false) {
          me.typing = true;
          set_typing(
            me.profile.room,
            me.profile.user_email,
            me.typing,
            !me.profile.is_admin
          );
          me.timeout = setTimeout(me.typing_timeout, 3000);
        }
      }
    });

    // Right-click on any message to trigger reply
    this.$wachat_space_container.on('contextmenu', '.sender-message, .recipient-message', (e) => {
      e.preventDefault();
      const $msg = $(e.currentTarget);
      const msgId = $msg.attr("data-message-id") || ""
      const sender = $msg.find('.message-name').text() || '';
      // const text = $msg.find('.message-bubble').text() || '';
      const $img = $msg.find('img.wachat-image');
      const $file = $msg.find('.message-bubble a[href]');
      const attachment = $img.attr('src') || $file.attr('href') || '';


      const orig = this.messages.find((m) => (m.message_id || m.name) === msgId);
      // let text = quote_label(text, attachment, orig?.file_type);
      let text = quote_label(
        orig?.content || $msg.find('.message-caption').text().trim(),
        attachment,
        orig?.file_type
      );
      const isOutgoing = $msg.hasClass('recipient-message');
      this.reply_to = {
        id: msgId,
        sender: sender,
        text: text,
        attachment: attachment,
        file_type: orig?.file_type || '',
      };

      // Close reply preview
      this.$reply_preview.find('.wachat-reply-close').on('click', () => {
        this.$reply_preview.hide();
        this.reply_to = null;
      });
      this.$reply_preview.find('.wachat-reply-sender').text(sender);
      // this.$reply_preview.find('.wachat-reply-sender').text(sender + ': ');
      this.$reply_preview.find('.wachat-reply-text').text(text);
      this.$reply_preview.show();
    });

  }

  setup_socketio() {
    const me = this;

    frappe.realtime.on(this.profile.room, function (res) {
      me.receive_message(res, get_time(res.creation));
    });

    frappe.realtime.on(this.profile.room + ':typing', function (res) {
      me.get_typing_changes(res);
    });
  }

  destroy_socket_events() {
    frappe.realtime.off(this.profile.room);
    frappe.realtime.off(this.profile.room + ':typing');
  }

  get_typing_changes(res) {
    if (res.user != this.profile.user_email) {
      if (
        (this.profile.is_admin === true && res.is_guest === 'true') ||
        this.profile.is_admin === false ||
        this.profile.room_type === 'Group' ||
        this.profile.room_type === 'Direct'
      ) {
        if (res.is_typing === 'false') {
          $('.wachat-profile-status').css('visibility', 'hidden');
        } else {
          $('.wachat-profile-status').css('visibility', 'visible');
          const timeout = setTimeout(() => {
            $('.wachat-profile-status').css('visibility', 'hidden');
          }, 3000);
        }
      }
    }
  }


  make_message(content, attachment, time, type, name, status, wa_id = "", reply_to_id = "", reply_preview = "", reply_attachment = "", file_type = "", reply_file_type = "") {
    const displayCaption = get_display_caption(content);
    const message_class =
      type === 'recipient' ? 'recipient-message' : 'sender-message';
    const $recipient_element = $(document.createElement('div')).addClass(
      message_class
    );
    const $message_element = $(document.createElement('div')).addClass(
      'message-bubble'
    );

    const $name_element = $(document.createElement('div'))
      .addClass('message-name')
      .text(name);

    const $attach_element = $(document.createElement('div'))
      .addClass('message-name')
      .text('Media Attachment');

    const $caption_element = $(document.createElement('div'))
      .addClass('message-caption')
      .text("Caption: " + content);

    const contentStr = String(content || '');
    const typeStr = String(file_type || '').toLowerCase();
    const attachmentStr = String(attachment || '');
    const media_url = attachmentStr || (
      contentStr.startsWith('/files/') || contentStr.startsWith('http') ? contentStr : ''
    );
    // const media_url = attachment || (
    //   content && (content.startsWith('/files/') || content.startsWith('http'))
    //     ? content
    //     : ''
    // );
    const file_name = (media_url.split('?')[0].split('/').pop() || '');
    const isDocument =
      typeStr === 'document' ||
      typeStr.startsWith('application/') ||
      /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|txt|csv|zip)$/i.test(file_name);


    const caption =
      content && !content.startsWith('/files/') && !content.startsWith('http')
        ? content
        : '';

    let $sanitized_content;

    if (media_url && is_image(file_name) && !isDocument) {

      const $wrap = $(document.createElement('div'));
      const $img = $(document.createElement('img'));
      $img.attr({ src: media_url }).addClass('img-responsive wachat-image');

      const $download = $(document.createElement('a'));
      $download
        .attr({
          href: media_url,
          target: '_blank',
          download: file_name || 'image',
        })
        .text(__('Download Image'));
      if (type === 'sender') {
        // $download.css('color', 'var(--cyan-600)');
        $download.addClass('message-download-link');

      }
      $wrap.append($img);
      $wrap.append($download);
      $message_element.addClass('message-bubble--media');

      // $message_element.css({ padding: '0px', background: 'inherit' });
      $sanitized_content = $wrap;
      if (caption && caption !== '📎 Media' && caption !== '📷 Image' && caption !== 'New Attachment') {
        $message_element.append(
          $(document.createElement('div')).addClass('message-caption').text(caption)
        );
      }
    }

    else if (media_url) {
      const $wrap = $(document.createElement('div'));
      const $url = $(document.createElement('a'));
      $url
        .attr({ href: media_url, target: '_blank', download: file_name || 'file' })
        .addClass('message-download-link')
        .text(__('Download'));
      $wrap.append($url);
      $sanitized_content = $wrap;
      // Show caption for documents (same as images)
      const trimmedCaption = String(caption || '').trim();
      if (
        trimmedCaption &&
        trimmedCaption !== '📎 Media' &&
        trimmedCaption !== '📷 Image' &&
        trimmedCaption !== '📄 Document' &&
        trimmedCaption !== 'New Attachment'
      ) {
        $message_element.append(
          $(document.createElement('div')).addClass('message-caption').text(trimmedCaption)
        );
      }
      // if (displayCaption) {
      //   $message_element.append(
      //     $(document.createElement('div')).addClass('message-caption').text(displayCaption)
      //   );
      // }
    }
    else {
      $sanitized_content = __($('<div>').text(content || '').html());
    }



    if (type === 'sender' && this.profile.room_type === 'Group') {
      $message_element.append($name_element);
    }
    $recipient_element.attr("data-message-id", wa_id || "");

    if ((reply_preview && String(reply_preview).trim()) || reply_attachment) {
      const label = quote_label(reply_preview, reply_attachment, reply_file_type);

      const thumbName = (String(reply_attachment).split('?')[0].split('/').pop() || '');
      const quotedIsDocument = is_document_file(thumbName, reply_file_type);

      const thumb =
        reply_attachment && is_image(thumbName) && !quotedIsDocument
          ? `<img src="${frappe.utils.escape_html(reply_attachment)}"
        style="width:32px;height:32px;object-fit:cover;border-radius:4px;float:right;margin-left:6px;">`
          : '';
      $message_element.append(`
    <div class="wachat-quoted" style="
      border-left: 3px solid #00a2ff;
      background: rgba(0,0,0,0.05);
      padding: 4px 8px;
      margin-bottom: 4px;
      font-size: 12px;
      overflow: hidden;
    ">${thumb}${frappe.utils.escape_html(label)}</div>
  `);
    }
    $message_element.append($sanitized_content);
    $recipient_element.append($message_element);
    $recipient_element.append(`<div class='message-time'>${__(time)}</div>`);
    if (type === 'recipient') {
      $recipient_element.append(`<div class='message-time'>Sent by ${name}</div>`);
    }
    if (status && type === 'recipient') {
      $recipient_element.append(`<div class='message-time'>Msg Status: ${status}</div>`);
    }
    return $recipient_element;
  }



  _pushAndPaint(msg, type) {
    this.messages.push(msg);
    this.$wachat_messages.append(
      this.make_message(
        msg.content, msg.attachment, get_time(msg.creation), type,
        msg.sender, msg.status, msg.message_id,
        msg.reply_to_message_id, msg.reply_preview,
        msg.reply_attachment, msg.file_type, msg.reply_file_type
      )
    );
    this.$wachat_space_container[0].scrollTop =
      this.$wachat_space_container[0].scrollHeight;
  }

  handle_send_message(attachment = null) {

    // const $type_message = $('.type-message');
    const $type_message = this.$wachat_space.find('.type-message');
    const message = $type_message.val()?.trim() || '';

    if (!message && !attachment) {
      return;
    }

    this.typing = false;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    if (
      this.profile.is_admin === true &&
      frappe.Wachat.settings.user.enable_message_tone === 1
    ) {
      frappe.utils.play_sound('wachat-message-send');
    }

    const reply_id = this.reply_to?.id || "";
    const reply_text = this.reply_to?.text || "";
    const now = frappe.datetime.now_datetime();

    const localMsg = {
      content: message,
      attachment: attachment || '',
      sender: this.profile.user,
      creation: now,
      sender_email: this.profile.user_email,
      client: 0,
      is_template: 0,
      message_id: "",
      reply_to_message_id: reply_id,
      reply_preview: reply_text,
      reply_attachment: this.reply_to?.attachment || "",
      reply_file_type: this.reply_to?.file_type || "",
    };

    // this.allMessages.push(localMsg);
    this._pushAndPaint(localMsg, 'recipient');

    // Clear text box
    $type_message.val('');
    this.reply_to = null;
    this.$reply_preview.hide();
    send_message(
      message,
      this.profile.user,
      this.profile.room,
      this.profile.user_email,
      attachment || "",
      reply_id
    );

  }


  receive_message(res, time) {
    if (!this.$wachat_messages) return;

    const isOwnEcho = !isTemplate && res.client !== 1 && res.sender_email === this.profile.user_email;
    if (isOwnEcho) return;
    if (!isTemplate && res.sender_email === this.profile.user_email) return;
    // if (res.sender_email === this.profile.user_email) {
    //   return;
    // }
    const id = res.message_id || "";
    if (id && this.messages.some((m) => m.message_id === id)) return;

    if (
      this.profile.is_admin === true &&
      $('.wachat-element').is(':visible') &&
      frappe.Wachat.settings.user.enable_message_tone === 1
    ) {
      frappe.utils.play_sound('wachat-message-receive');
    }



    const rid = res.reply_to_message_id;
    const orig = (rid && String(rid).trim())
      ? this.messages.find(m => m.message_id && m.message_id === rid)
      : null;
    const reply_preview = (res.reply_preview && String(res.reply_preview).trim())
      || (orig && quote_label(orig.content, orig.attachment, orig.file_type))
      || "";
    const incoming = {
      content: res.content,
      attachment: res.attachment || "",
      sender: res.user,
      creation: res.creation || frappe.datetime.now_datetime(),
      sender_email: res.sender_email,
      client: 1,
      is_template: 0,
      status: res.status || "",
      message_id: res.message_id || "",
      reply_to_message_id: reply_preview ? rid : "",
      reply_preview: reply_preview,
      reply_attachment: reply_preview ? (res.reply_attachment || (orig && orig.attachment) || "") : "",
      file_type: res.file_type || "",
      reply_file_type: res.reply_file_type || (orig && orig.file_type) || "",
    };

    const wachat_type = incoming.client === 1 ? 'sender' : 'recipient';
    this._pushAndPaint(incoming, wachat_type);
    this.timediff = 0;
    this.lasttime = incoming.creation;
    const $input = this.$wachat_actions && this.$wachat_actions.find('.type-message');
    if ($input && $input.length) {
      $input.prop('disabled', false).attr('placeholder', __('Type message'));
    }

  }

  // render() {
  //   this.$wrapper.html(this.$wachat_space);
  //   this.setup_events();

  //   scroll_to_bottom(this.$wachat_space_container);
  // }
  render() {
    this.$wachat_space.detach();
    this.$wrapper.children().detach();
    this.$wrapper.append(this.$wachat_space);

    if (!this.events_bound) {
      this.setup_events();
      this.events_bound = true;
    }
    this.$wachat_space.off('click', '.wachat-load-prev-btn').on('click', '.wachat-load-prev-btn', () => {
      this.loadPreviousBatch();
    });
    // this.$floating_btn.off('click').on('click', () => {
    //   this.loadPreviousBatch();
    // });

    if (this.$wachat_space_container && this.$wachat_space_container[0]) {
      scroll_to_bottom(this.$wachat_space_container);
    }
  }
}
